import { truncateWithEllipsis } from '@kaiizen/kai-presenters';
import type { ScanPhoto } from '@kaiizen/kai-scan-template-system';

import type { GalleryPhotoOccurrence } from '../../FocusedPhotoGallery/galleryPhotoOperations';
import {
  type FocusedPhotoStripEntry,
  GROUP_PHOTO_CHIP_LABEL,
  PHOTO_CHIP_LABEL_MAX_LENGTH,
  TASK_PHOTO_CHIP_LABEL_FALLBACK,
} from './focusedStripTypes';

export const getTruncatedChipLabel = (label: string): string => truncateWithEllipsis(label, PHOTO_CHIP_LABEL_MAX_LENGTH);

const getPhotoSourceVerb = (photo: FocusedPhotoStripEntry): string => photo.photoSource === 'upload' ? 'Uploaded' : 'Captured';

export const toDraggedOccurrence = (photo: FocusedPhotoStripEntry): GalleryPhotoOccurrence => ({
  key: photo.photoId,
  photo: { photoId: photo.photoId } as ScanPhoto,
  context: { groupId: photo.groupId, taskId: photo.taskId },
  sectionTitle: '',
});

export const getPhotoTileLabel = (photo: FocusedPhotoStripEntry, authorName?: string): string =>
  [
    photo.scope === 'group'
      ? photo.groupLabel ?? GROUP_PHOTO_CHIP_LABEL
      : photo.taskLabel ?? TASK_PHOTO_CHIP_LABEL_FALLBACK,
    photo.dateLabel,
    photo.walkLabel,
    authorName ? `${getPhotoSourceVerb(photo)} by ${authorName}` : undefined,
  ].filter(Boolean).join(' · ');

export const getDragSourcesForPhoto = (
  photo: FocusedPhotoStripEntry,
  visiblePhotos: readonly FocusedPhotoStripEntry[],
  selectedPhotoIds: ReadonlySet<string>,
): readonly GalleryPhotoOccurrence[] => {
  const selected = selectedPhotoIds.has(photo.photoId);
  if (selectedPhotoIds.size > 1 && selected) {
    return visiblePhotos
      .filter(candidate => selectedPhotoIds.has(candidate.photoId))
      .map(toDraggedOccurrence);
  }
  return [toDraggedOccurrence(photo)];
};
